<script>
export default {
  name: 'RoomType',
  data() {
    return {
      room_type: {
        room_type_name: '',
      },
    }
  },
  methods: {
    newRoomType() {
      console.log(this.room_type.room_type_name)
      this.$axios.post(this.$endpoint.CreateRoomType, {room_type_name: this.room_type.room_type_name})
    },
  },

}
</script>

<template>
  <div>
    <v-row>
      <v-col
          cols="12"
          md="12"
      >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouveau type de chambre
            </span>
      </v-col>
    </v-row>
    <v-form
        class="multi-col-validation"
        style="margin-top:1rem; margin-left: 1rem; margin-bottom: 1.5rem;"
    >
      <v-row>
        <v-col
            cols="12"
            md="6"
        >
          <v-text-field
              v-model="room_type.room_type_name"
              dense
              hide-details
              label="Designation"
              outlined
              placeholder="Designation"
          ></v-text-field>
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
        </v-col>

        <v-col
            cols="12"
            md="6"
        >
        </v-col>

        <v-col cols="12">
        </v-col>

        <v-col cols="12">
          <v-btn
              color="primary"
              @click="newRoomType"
          >
            Creer
          </v-btn>
          <v-btn
              class="mx-2"
              outlined
              type="reset"
          >
            Annuler
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<style scoped>

</style>